import { Module, VuexModule, Mutation, MutationAction, getModule, Action } from 'vuex-module-decorators';
import store from '@/store';
import { AppSettings } from '@/models/settings/AppSettings';
import { AppSettingsService } from '@/services';
import { EditorModeEnums } from '@/enums/EditorModeEnums';
import { LoggerService } from '@/utils';


export interface IAppSettingsStoreState {
    appStarted: boolean;
    actualEditMode: EditorModeEnums;

}

@Module({ dynamic: true, store, name: 'appSettingsStore' })
class AppSettingsStoreModule extends VuexModule implements IAppSettingsStoreState {
    public appStarted: boolean = false;
    public actualEditMode: EditorModeEnums = EditorModeEnums.UNKNOWN;
    public directOpenId: string | undefined = undefined;

    @Mutation
    public SetAppStarted() {
        // should only be set in vuex store to be reset after page refresh
        this.appStarted = true;
    }

    @Mutation
    public SetAppStoped() {
        // should only be set in vuex store to be reset after page refresh
        this.appStarted = false;
    }


    @Mutation
    public SetEditMode(editMode: EditorModeEnums) {
        this.actualEditMode = editMode;
    }

    @MutationAction({ mutate: ['directOpenId'] })
    public async SetDirectOpenId(directOpenId: string | undefined) {
        return { directOpenId };
    }

    get GetAppStarted() {
        return this.appStarted;
    }

    get GetActualEditMode() {
        return this.actualEditMode;
    }

    get GetDirectOpenId() {
        return this.directOpenId;
    }
}

export const AppSettingsStore = getModule(AppSettingsStoreModule);
